// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Decco from "decco/src/Decco.bs.mjs";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as SnapshotTrackerId$FeedSync from "./SnapshotTrackerId.bs.mjs";

function t_encode(v) {
  return Js_dict.fromArray([[
                "trackerId",
                Curry._1(SnapshotTrackerId$FeedSync.t_encode, v.trackerId)
              ]]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var trackerId = Curry._1(SnapshotTrackerId$FeedSync.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "trackerId"), null));
  if (trackerId.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              trackerId: trackerId._0
            }
          };
  }
  var e = trackerId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".trackerId" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

var codec = [
  t_encode,
  t_decode
];

var toJson = t_encode;

var fromJson = t_decode;

export {
  t_encode ,
  t_decode ,
  codec ,
  toJson ,
  fromJson ,
}
/* SnapshotTrackerId-FeedSync Not a pure module */
